<div class="row">
    <div class="col-lg-6 col-sm-12 col-xs-12">
        <div class="row chart" #panel>
                <kla-single-donut  *ngIf="showChart" id="{{chartConfig.id}}" [config]="chartConfig" [width]="chartConfig.width "></kla-single-donut>
                </div>
            </div>
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <kla-title [lineConfig]="lineConfig" [config]="config.title"></kla-title>
    </div>

  </div>
